import {
  UPLOAD_IMAGE,
  START,
  SUCCESS,
  TICK,
  FAIL,
  CHANGE_SOURCE_UPLOADER,
  THIRD_PARTY_SEARCH,
  INCREMENT_THIRD_PARTY_SEARCH_PAGE,
  TOGGLE_MODAL,
  SET_THIRD_PARTY_SEARCH_QUERY
} from "../constants/action-types";

export default (
  uploader = {
    query: ``,
    page: 0,
    loading: false,
    loaded: false
  },
  action
) => {
  const {type, payload, error} = action;
  switch (type) {
    case UPLOAD_IMAGE + START:
      return {...uploader, loading: true, loaded: false};
    case UPLOAD_IMAGE + TICK:
      return {...uploader, progress: payload.progress};
    case UPLOAD_IMAGE + SUCCESS:
      return {...uploader, loading: false, loaded: true};
    case UPLOAD_IMAGE + FAIL:
      return {...uploader, error, loading: false, loaded: false};

    case CHANGE_SOURCE_UPLOADER:
      return {...uploader, source: payload.source};
    case TOGGLE_MODAL:
      return {...uploader, source: `local`};

    case THIRD_PARTY_SEARCH + START:
      return {
        ...uploader,
        loading: true,
        loaded: false
      };
    case THIRD_PARTY_SEARCH + SUCCESS:
      return {
        ...uploader,
        loading: false,
        loaded: true,
        data: [...uploader.data, payload.data]
      };
    case THIRD_PARTY_SEARCH + FAIL:
      return {
        ...uploader,
        loading: false,
        loaded: true
      };
    case SET_THIRD_PARTY_SEARCH_QUERY:
      return {
        ...uploader,
        query: payload.query,
        data: [],
        page: 0
      };
    case INCREMENT_THIRD_PARTY_SEARCH_PAGE:
      return {
        ...uploader,
        page: uploader.page + 1
      };
  }
  return uploader;
};
